module.exports = __webpack_public_path__ + "img/list-thumbnail-none.5191d25b.png";